import type { IconName } from '../icons';

export interface NavItem { to: string; label: string; short: string; icon: IconName; id: string }

const footprint: NavItem = { to: '/', label: 'Digital Footprint', short: 'Footprint', icon: 'fingerprint', id: 'footprint' };
const findings: NavItem = { to: '/findings', label: 'Findings', short: 'Findings', icon: 'list-check', id: 'findings' };
const resolve: NavItem = { to: '/resolve', label: 'Resolve', short: 'Resolve', icon: 'wand-magic-sparkles', id: 'resolve' };
const watchlist: NavItem = { to: '/watchlist', label: 'Watchlist', short: 'Watchlist', icon: 'eye', id: 'watchlist' };
const settings: NavItem = { to: '/settings', label: 'Settings', short: 'Settings', icon: 'gear', id: 'settings' };

// DWM sidebar groups, divided like DWMSidebar: home | work | setup.
export const RAIL_GROUPS: NavItem[][] = [[footprint], [findings, resolve], [watchlist, settings]];
// Mobile tab bar: Footprint in the middle.
export const TAB_NAV: NavItem[] = [findings, resolve, footprint, watchlist, settings];

// Footprint lab (design exploration): one link per variant, shown as its own sidebar group.
export const LAB_NAV = [
  ['calm-ring', 'Calm ring'], ['proximity-radar', 'Proximity radar'], ['constellation', 'Constellation'], ['wallet-cards', 'Wallet cards'],
  ['command-center', 'Command center'], ['focus-story', 'Focus story'], ['exposure-blocks', 'Exposure blocks'], ['time-river', 'Time river'],
  ['shield-rings', 'Shield rings'], ['identity-flow', 'Identity flow'],
].map(([slug, name], i) => ({ to: `/lab/${slug}`, label: `${i + 1}. ${name}`, short: name, icon: 'fingerprint' as IconName, id: `lab-${slug}` }));

// Page title shown in the header (DWM pattern); /scan renders its own.
export function titleFor(pathname: string): string {
  if (pathname.startsWith('/findings/')) return 'Finding';
  if (pathname.startsWith('/lab')) return LAB_NAV.find((l) => l.to === pathname)?.short ? `Footprint lab · ${LAB_NAV.find((l) => l.to === pathname)!.short}` : 'Footprint lab';
  return [footprint, findings, resolve, watchlist, settings].find((i) => i.to === pathname)?.label ?? 'Nord Monitor';
}
